import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import AppLayout from '../../../../../../layout/components/AppLayout';
import tenderServices from '../tenderServices';
import TenderForm from '../components/TenderForm';
import { useAppData } from '../../../../../../context/AppDataContext';
import moment from 'moment';
import { Cancel, Edit, Save } from '@mui/icons-material';
import { Switch } from '@mui/material';


const InputEditor = ({type,field,value,label,callBack}) =>{
    //const [val,setVal] = useState(value!==null?value:moment().format(moment.HTML5_FMT.DATE));
    const [val,setVal] = useState(value);
    const [editing,setEditingStatus] = useState(false);
    const onSave = () =>{
        setEditingStatus(false);
        callBack({[field]:val})
    }

    return (
        <div className='row'>
            <div className='col-md-4 fw-bold'>{label} :</div>
            <div className='col-md-8'>
                    {editing ?
                        <div className="input-group mb-3">
                            <input type={type} className='form-control'
                                value={val}
                                onChange={(e)=>setVal(e.target.value)}
                            />
                            <button className='btn btn-outline-success' onClick={onSave} ><Save/></button>
                            <button className='btn btn-outline-danger' onClick={()=>setEditingStatus(false)} ><Cancel/></button>
                        </div>
                        :
                        <div className="input-group mb-3">
                            {type == "date" ?
                                <span className="input-group-text" >
                                    {val ? moment(val).format("LL") : "Not Available"}
                                </span>
                                :
                                <span className="input-group-text" >{val?val:"Not Available"}</span>
                            }
                            <button className='btn btn-outline-dark' onClick={()=>setEditingStatus(true)} ><Edit/></button>
                            
                        </div>
                    }
            </div>
        </div>
    )
}

const SwitchEditor = ({field, value, label, callBack}) => {
    // Sync internal state with prop
    const handleChange = (e) => {
        const newValue = e.target.checked;
        // Don't use a useEffect for saving; call it directly on change
        callBack({ [field]: newValue });
    };

    return (
        <div className='row align-items-center mb-2'>
            <div className='col-md-4 fw-bold'>{label}</div>
            <div className='col-md-8'>
                <Switch checked={!!value} onChange={handleChange}/>
            </div>
        </div>
    );
};



function TenderDetailsPage() {
    const {id} = useParams();

    const {companyDD, getDDDataById, getMasterLabel} = useAppData();
    const [tenderDetails,setTenderDetails] = useState();
    const [loading,setLoadingStatus] = useState(false);

    const getTenderDetails = () =>{
        setLoadingStatus(true);
        tenderServices.getById(id).then(res=>{
            setTenderDetails(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>setLoadingStatus(false))
    }

    useEffect(()=>{
        getTenderDetails();
    },[id])

    const updateData = (payload)=>{
        payload.id = id;
        console.log(payload);
        tenderServices.save(payload).then(res=>{
            getTenderDetails();
        }).catch(error=>{
            console.log(error);
        })
    }

    return (
        tenderDetails &&
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-4'>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>{tenderDetails.title}</th>
                                    <td><TenderForm data={tenderDetails} callBack={getTenderDetails}/></td>
                                </tr>
                            </thead>
                            <tbody>
                                
                                <tr>
                                    <th>Company</th>
                                    <td>{getDDDataById(companyDD,tenderDetails.companyId).label}</td>
                                </tr>

                                <tr>
                                    <th>Tender Type</th>
                                    <td>{ getMasterLabel("tender-type",tenderDetails.tenderType) }</td>
                                </tr>

                                <tr>
                                    <th>Tender #</th>
                                    <td>{tenderDetails.tenderNo}</td>
                                </tr>
                                <tr>
                                    <th>Work Location</th>
                                    <td>{tenderDetails.workLocation}</td>
                                </tr>
                                <tr>
                                    <th>Tender Amount</th>
                                    <td>{tenderDetails.tenderAmount}</td>
                                </tr>
                                <tr>
                                    <th>Bid Amount</th>
                                    <td>{tenderDetails.bidAmount}</td>
                                </tr>
                                <tr>
                                    <th>Gst Rate</th>
                                    <td>{tenderDetails.gstRate}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='col-md-8'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="financialBidDate" label="Financial Bid Date" value={tenderDetails.financialBidDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <SwitchEditor field="financialBidStatus" label="Financial Bid Status" value={tenderDetails.financialBidStatus} callBack={updateData} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="commercialBidDate" label="Commercial Bid Date" value={tenderDetails.commercialBidDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <SwitchEditor field="commercialBidStatus" label="CommercialBid Status" value={tenderDetails.commercialBidStatus} callBack={updateData} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="allotmentDate" label="Allotment Bid Date" value={tenderDetails.allotmentDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <SwitchEditor field="allotmentStatus" label="Allotment Status" value={tenderDetails.allotmentStatus} callBack={updateData} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="uiFeePaymentDate" label="UI Fee Payment Date" value={tenderDetails.uiFeePaymentDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <InputEditor type="text" field="uiFee" label="Ui Fee" value={tenderDetails.uiFee} callBack={updateData} />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="emdFeePaymentDate" label="Emd Fee Payment Date" value={tenderDetails.emdFeePaymentDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <InputEditor type="text" field="emdFee" label="Emd Fee" value={tenderDetails.emdFee} callBack={updateData} />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="pbgFeePaymentDate" label="PBG Fee Payment Date" value={tenderDetails.pbgFeePaymentDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <InputEditor type="text" field="pbgFee" label="PBG Fee" value={tenderDetails.pbgFee} callBack={updateData} />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="emdReturnDate" label="EMD Return Date" value={tenderDetails.emdReturnDate} callBack={updateData} />
                            </div>
                            <div className='col-md-6'>
                                <InputEditor type="date" field="pbgReturnDate" label="PBG Return Date" value={tenderDetails.pbgReturnDate} callBack={updateData} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </AppLayout>
    )
}

export default TenderDetailsPage